import { gql } from "gql";

export const REJECT_EXTERNAL_SIGNING = gql(/* GraphQL */ `
  mutation RejectExternalSigning($code: String!, $comment: String) {
    rejectExternalSigning(code: $code, comment: $comment) {
      ...SignRegistrationAfterExternalAction
    }
  }
`);
